import { ReactNode, CSSProperties } from 'react'

import { useHomeLink } from '~/hooks/useHomeLink'

import { Breakpoint, useCheckBreakpoint } from '~/utils'

import { LinkHoMLogo } from './LinkHoMLogo'

export type HeaderVariant = 'light' | 'translucent'

interface Props {
  showOnLargeScreen?: boolean
  style?: CSSProperties
  leftAddon?: ReactNode
  className?: string
  rightAddon?: ReactNode
  isLogoH1?: boolean
  isLeftLogo?: boolean
  variant?: HeaderVariant
}

export function LogoTop({
  showOnLargeScreen = false,
  style,
  leftAddon,
  rightAddon,
  className = '',
  isLogoH1,
  isLeftLogo,
  variant = 'light',
}: Props): React.ReactElement {
  const logoRoute = useHomeLink()

  const isDesktop = useCheckBreakpoint({ gt: Breakpoint.LG })
  if (!showOnLargeScreen && isDesktop) return <></>

  return (
    <div
      className={
        `sticky top-0 w-full z-75 ${className} ` +
        `flex items-center ${isLeftLogo ? 'justify-between md:pl-2' : 'justify-center'} ${
          variant === 'translucent' ? 'bg-white/10' : 'border-b border-gray-light bg-white drop-shadow-xl'
        }`
      }
      style={{ zIndex: 999, ...style }}
    >
      {leftAddon}
      {isLogoH1 ? (
        <h1>
          <LinkHoMLogo logoRoute={logoRoute} />
        </h1>
      ) : (
        <LinkHoMLogo logoRoute={logoRoute} />
      )}
      {rightAddon}
    </div>
  )
}
